import React from "react";
import PropTypes from "prop-types";
import CompanyRecommendArticleBox from "../common/RecommendArticleBox";

function CompanyPCRecommendArticlesBox({
  heading,
  articles = [],
  idx,
  company_name,
}) {
  return (
    <div className="m_recommendBox">
      <h4 className="p_insertionHeading">{heading}</h4>
      <div
        className="jsSlideArrow slideArrow isLeft isDisable"
        data-idx={idx}
        data-direction="left"
      />
      <ul className={`recommendUl jsRecommend${idx}`} data-idx={idx}>
        {articles.map((article) => (
          <CompanyRecommendArticleBox
            key={article.id}
            article={article}
            company_name={company_name}
          />
        ))}
      </ul>
      <div
        className="jsSlideArrow slideArrow isRight"
        data-idx={idx}
        data-direction="right"
      />
    </div>
  );
}

CompanyPCRecommendArticlesBox.propTypes = {
  heading: PropTypes.string.isRequired,
  articles: PropTypes.arrayOf(PropTypes.object),
  idx: PropTypes.number.isRequired,
  company_name: PropTypes.string.isRequired,
};

CompanyPCRecommendArticlesBox.defaultProps = {
  articles: [],
};

export default CompanyPCRecommendArticlesBox;
